import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [sharedState, setSharedState] = useState({});

    return (
        <AppContext.Provider value={{ sharedState, setSharedState }}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => useContext(AppContext);